import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import Collapsable from './Collapsable';
import GroupsList from './GroupsList';
import EmptySet from './EmptySet';

import { SetListItem, LockedMessage } from './ListItem.styled';

const GroupSetListItem = ({
  set,
  name,
  isHidden,
  isLocked,
  groups,
  isInstructor,
  onEditGroupSet,
  onCreateGroup,
  onGenerateGroups,
}) => {
  const hasGroups = useMemo(() => groups.length > 0, [groups]);

  if (isHidden && !isInstructor) {
    return null;
  }

  const footerVisible = isInstructor && hasGroups && !isLocked;
  const content =
    isInstructor && !hasGroups ? (
      <EmptySet
        onNewGroup={onCreateGroup}
        onAutoGenerateGroup={onGenerateGroups}
      />
    ) : (
      <GroupsList groups={groups} />
    );

  const titleDecoration = isLocked ? (
    <LockedMessage>
      This set of groups is attached to an assignment with student submissions.
      Some options will not be available.
    </LockedMessage>
  ) : null;

  return (
    <SetListItem className="group-set">
      <Collapsable
        id={`group-set${set}`}
        expandedByDefault
        title={name}
        titleDecoration={titleDecoration}
        hiddenButtonVisible={isHidden}
        lockedMessageVisible={isLocked}
        hiddenButtonLabel="Set hidden from students"
        moreButtonVisible={isInstructor}
        moreButtonLabel="Edit set"
        onMoreButtonClicked={onEditGroupSet}
        footerVisible={footerVisible}
        footerActionLabel="Add new group"
        onFooterActionClicked={onCreateGroup}
      >
        {content}
      </Collapsable>
    </SetListItem>
  );
};

GroupSetListItem.propTypes = {
  set: PropTypes.string,
  name: PropTypes.string,
  isHidden: PropTypes.bool,
  isLocked: PropTypes.bool,
  groups: PropTypes.arrayOf(PropTypes.string),
  isInstructor: PropTypes.bool,
  onEditGroupSet: PropTypes.func.isRequired,
  onCreateGroup: PropTypes.func.isRequired,
  onGenerateGroups: PropTypes.func.isRequired,
};

GroupSetListItem.defaultProps = {
  set: '',
  name: '',
  isHidden: false,
  isLocked: false,
  groups: [],
  isInstructor: false,
};

export default GroupSetListItem;
